import { $page_bottega } from '@velasca/utils/globals'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'

const TopSection = () => {
  return (
    <div id="content" className="top-section col-md-4 col-md-offset-4">
      <div
        className="pretitle"
        dangerouslySetInnerHTML={sanitizeHTML($page_bottega.pretitle)}
      ></div>
      <h3 dangerouslySetInnerHTML={sanitizeHTML($page_bottega.title_02)}></h3>
      <div className="paragraph">
        <p dangerouslySetInnerHTML={sanitizeHTML($page_bottega.paragraph)}></p>
      </div>
    </div>
  )
}

export default TopSection
